"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9460],{

/***/ 19460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var draft_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9041);
/* harmony import */ var draft_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(draft_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Validations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6686);
/* harmony import */ var _libs_useTheme__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5779);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51773);
/* harmony import */ var _libs_Utility_resizeable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58118);
/* harmony import */ var _components_tootilp_Tooltip__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73912);
/* harmony import */ var _libs_Utility_util__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52229);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var draftjs_to_html__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(89265);
/* harmony import */ var draftjs_to_html__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(draftjs_to_html__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _TextEditorUtil__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(99212);













const DynamicEditor = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 6925).then(__webpack_require__.t.bind(__webpack_require__, 35108, 23)).then((mod)=>mod.Editor), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(35108)
            ]
    },
    ssr: false
});
const RichTextEditor = (param)=>{
    let { label , placeholder , className , validations , required , hint , testid , onChange , value , show =true , textColour , labelBgColour , tooltip , setError , htmlOutput =false , resizeEnabled =true , decorators  } = param;
    // console.log({ value })
    const { theme  } = (0,_libs_useTheme__WEBPACK_IMPORTED_MODULE_5__/* .useTheme */ .Fg)();
    const { isReady  } = (0,next_router__WEBPACK_IMPORTED_MODULE_10__.useRouter)();
    const [error, setLocalError] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [showTooltip, setShowTooltip] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        // Autohide tooltip if the input is not required.
        if ((tooltip === null || tooltip === void 0 ? void 0 : tooltip.toLowerCase().includes("require")) && !required) setShowTooltip(false);
    }, [
        tooltip,
        required
    ]);
    const [editorState, setEditorState] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(()=>draft_js__WEBPACK_IMPORTED_MODULE_2__.EditorState.createEmpty());
    const editorStateRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(editorState);
    editorStateRef.current = editorState;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        // console.log({ value, valueType: typeof value, window: !!window, isReady })
        if (!isReady) return;
        if (value && typeof value === "string" && value.trim() !== "" && !!window) {
            try {
                if (htmlOutput && !(0,_libs_Utility_util__WEBPACK_IMPORTED_MODULE_9__/* .isJSON */ .pM)(value)) {
                    console.log("HTML", {
                        value
                    });
                    const rawContentFromProps = (0,draft_js__WEBPACK_IMPORTED_MODULE_2__.convertFromHTML)(value);
                    const contentState = draft_js__WEBPACK_IMPORTED_MODULE_2__.ContentState.createFromBlockArray(rawContentFromProps.contentBlocks, rawContentFromProps.entityMap);
                    setEditorState(draft_js__WEBPACK_IMPORTED_MODULE_2__.EditorState.createWithContent(contentState));
                } else {
                    console.log("Not HTML", {
                        value
                    });
                    const rawContentFromProps1 = JSON.parse(value);
                    const contentState1 = (0,draft_js__WEBPACK_IMPORTED_MODULE_2__.convertFromRaw)(rawContentFromProps1);
                    setEditorState(draft_js__WEBPACK_IMPORTED_MODULE_2__.EditorState.createWithContent(contentState1));
                }
            } catch (error) {
                console.error("Error to convert the initial value to EditorState: ", error);
            }
        }
    }, [
        isReady,
        window
    ]);
    const handleChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((0,_libs_Utility_util__WEBPACK_IMPORTED_MODULE_9__/* .debounce */ .Ds)((val)=>{
        if (onChange) {
            onChange(val);
        }
    }, 1000), []);
    if (!show) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    const parsedValidations = (0,_Validations__WEBPACK_IMPORTED_MODULE_4__/* .getDefaultValidations */ .C)(undefined, validations);
    const onEditorStateChange = (newEditorState)=>{
        setEditorState(newEditorState);
        const plainText = newEditorState.getCurrentContent().getPlainText("");
        const errorMessage = (0,_Validations__WEBPACK_IMPORTED_MODULE_4__/* .validate */ .G)(plainText, parsedValidations);
        var ref;
        if (!!setError) setError(errorMessage, (ref = testid !== null && testid !== void 0 ? testid : label) !== null && ref !== void 0 ? ref : "unknown");
        setLocalError(errorMessage);
        if (!errorMessage) {
            const rawContentState = (0,draft_js__WEBPACK_IMPORTED_MODULE_2__.convertToRaw)(newEditorState.getCurrentContent());
            let payload;
            htmlOutput ? payload = {
                data: JSON.stringify(rawContentState),
                markup: draftjs_to_html__WEBPACK_IMPORTED_MODULE_11___default()(rawContentState)
            } : payload = JSON.stringify(rawContentState);
            handleChange(payload);
        }
    };
    const isDarkTheme = theme.type === "DARK";
    // The toolbar does not pass EditorState to custom controls, so inject the
    // current state to let the size control report H1/H2/H3 accurately.
    const FontSizeControl = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextEditorUtil__WEBPACK_IMPORTED_MODULE_12__/* .FontSizeDropdown */ ._v, {
            ...props,
            editorState: editorStateRef.current
        });
    // const handleKeyCommand = (cmd: string): DraftHandleValue => {
    //   console.log({ cmd })
    //   if (cmd === 'init-autocomplete') {
    //     return 'handled'
    //   }
    //   return 'not-handled'
    // }
    //
    // console.log({ decorators })
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        className: [
            "flex flex-col my-3",
            className
        ].join(" "),
        style: {
            color: textColour
        },
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "mb-1.5 text-sm font-medium leading-5 transition-all ".concat(error ? "text-red-500" : ""),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_tootilp_Tooltip__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    show: showTooltip,
                    tooltip: tooltip,
                    className: "flex flex-col",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "z-10 ".concat(required ? "after:content-['*'] after:ml-1 after:text-red-500" : ""),
                        children: label
                    })
                })
            }),
             true && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_libs_Utility_resizeable__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                enabled: resizeEnabled,
                className: resizeEnabled ? "" : className,
                initalSize: {
                    height: 400
                },
                minHeight: 120,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DynamicEditor, {
                    spellCheck: true,
                    editorState: editorState,
                    onEditorStateChange: onEditorStateChange,
                    wrapperClassName: "".concat(resizeEnabled ? "size-full h-full overflow-hidden" : "w-full flex-1", " compact-rich-editor flex flex-col !box-border"),
                    /* @ts-ignore */ // keyBindingFn={keyBindingFn}
                    // handleKeyCommand={handleKeyCommand}
                    editorClassName: "my-rich-editor compact-rich-editor__content ".concat(error ? "text-red-500 border-red-500" : ""),
                    toolbarCustomButtons: htmlOutput ? [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextEditorUtil__WEBPACK_IMPORTED_MODULE_12__/* .PlaceholderButton */ .Kr, {
                            editorState: editorState,
                            onChange: setEditorState,
                            type: decorators ? "membership" : undefined
                        }, "placeholderButton")
                    ] : [],
                    toolbarClassName: "compact-rich-editor__toolbar flex flex-wrap justify-start gap-1 p-1.5 border-b border-gray-300 ".concat(isDarkTheme ? "text-blue-700 " : "text-black"),
                    toolbar: {
                        options: [
                            "fontFamily",
                            "fontSize",
                            "blockType",
                            "inline",
                            "list",
                            "link",
                            "image",
                            "colorPicker",
                            "remove",
                            "history"
                        ],
                        fontFamily: {
                            component: _TextEditorUtil__WEBPACK_IMPORTED_MODULE_12__/* .FontFamilyDropdown */ .hs,
                            options: [
                                _TextEditorUtil__WEBPACK_IMPORTED_MODULE_12__/* .DEFAULT_EDITOR_FONT_FAMILY */ .$b,
                                "Arial",
                                "Georgia",
                                "Impact",
                                "Tahoma",
                                "Times New Roman",
                                "Verdana"
                            ]
                        },
                        fontSize: {
                            component: FontSizeControl,
                            options: [
                                8,
                                9,
                                10,
                                11,
                                12,
                                14,
                                16,
                                18,
                                24,
                                30,
                                36,
                                40
                            ]
                        },
                        blockType: {
                            inDropdown: true,
                            options: [
                                "Normal",
                                "H1",
                                "H2",
                                "H3"
                            ]
                        },
                        inline: {
                            options: [
                                "bold",
                                "italic",
                                "underline",
                                "strikethrough"
                            ],
                            bold: {},
                            italic: {},
                            underline: {},
                            strikethrough: {}
                        },
                        list: {
                            options: [
                                "unordered",
                                "ordered"
                            ],
                            unordered: {},
                            ordered: {}
                        },
                        link: {
                            inDropdown: false,
                            className: undefined,
                            component: undefined,
                            popupClassName: undefined,
                            dropdownClassName: undefined,
                            showOpenOptionOnHover: true,
                            defaultTargetOption: "_self",
                            options: [
                                "link",
                                "unlink"
                            ],
                            linkCallback: undefined
                        },
                        image: {
                            alt: {
                                present: true,
                                mandatory: false
                            },
                            defaultSize: {
                                height: "auto",
                                width: "auto"
                            },
                            uploadEnabled: false,
                            inputAccept: "image/*",
                            previewImage: false
                        },
                        remove: {},
                        history: {
                            options: [
                                "undo",
                                "redo"
                            ],
                            undo: {},
                            redo: {}
                        }
                    },
                    customDecorators: decorators !== null && decorators !== void 0 ? decorators : _TextEditorUtil__WEBPACK_IMPORTED_MODULE_12__/* .EditorFullCustomDecorators */ .kW,
                    placeholder: placeholder,
                    "data-testid": testid !== null && testid !== void 0 ? testid : undefined
                })
            }),
            hint && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "mt-1 mb-4 text-xs",
                children: hint
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_6__["default"], {
                ignoreTheme: true,
                className: "mt-1 transition-all ".concat(error ? "opacity-100 text-red-500" : "opacity-0"),
                children: error || "-"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RichTextEditor);


/***/ }),

/***/ 99212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$b": function() { return /* binding */ DEFAULT_EDITOR_FONT_FAMILY; },
/* harmony export */   "Kr": function() { return /* binding */ PlaceholderButton; },
/* harmony export */   "Of": function() { return /* binding */ EditorMembershipCustomDecorators; },
/* harmony export */   "_v": function() { return /* binding */ FontSizeDropdown; },
/* harmony export */   "hs": function() { return /* binding */ FontFamilyDropdown; },
/* harmony export */   "js": function() { return /* binding */ TextEditorPlaceholders; },
/* harmony export */   "kW": function() { return /* binding */ EditorFullCustomDecorators; },
/* harmony export */   "qj": function() { return /* binding */ PLACEHOLDER_REGEX; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var draft_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9041);
/* harmony import */ var draft_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(draft_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);




// NOTE: Utility Functions
const findWithRegex = (regex, contentBlock, callback)=>{
    const text = contentBlock.getText();
    let matchArr, start;
    while((matchArr = regex.exec(text)) !== null){
        start = matchArr.index;
        callback(start, start + matchArr[0].length);
    }
};
// NOTE: Placeholder Logic
const TextEditorPlaceholders = [
    {
        label: "First Name",
        type: [
            "event",
            "membership"
        ],
        value: "{{firstname}} ",
        dummyData: "John"
    },
    {
        label: "Last Name",
        type: [
            "event",
            "membership"
        ],
        value: "{{lastname}} ",
        dummyData: "Smith"
    },
    {
        label: "Event Name",
        type: [
            "event"
        ],
        value: "{{title}} ",
        dummyData: "Forumm Event",
        useRealDataIfAvailable: true
    },
    {
        label: "Membership Name",
        type: [
            "membership"
        ],
        value: "{{title}} ",
        dummyData: "Forumm Membership",
        useRealDataIfAvailable: true
    },
    {
        label: "Event Link",
        type: [
            "event"
        ],
        value: "{{eventlink}} ",
        dummyData: '<a href="www.forumm.to">Event Page</a>',
        useRealDataIfAvailable: true
    },
    // {
    //   label: 'Recipient Email',
    // type: ['event'],
    //   value: '{{email}} ',
    //   dummyData: 'j.smith@forumm.to',
    // },
    {
        label: "Start Date & Time",
        type: [
            "event"
        ],
        value: "{{startdatetime}} ",
        dummyData: moment__WEBPACK_IMPORTED_MODULE_3___default()().format("D MMMM YYYY, h:mm A"),
        useRealDataIfAvailable: true
    },
    {
        label: "Location",
        type: [
            "event"
        ],
        value: "{{eventlocation}} ",
        dummyData: "Glasgow",
        useRealDataIfAvailable: true
    },
    {
        label: "QR Code",
        type: [
            "event"
        ],
        value: "{{qr}} ",
        dummyData: '<img src="https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=dummycode" alt="QR Code" />'
    },
    {
        label: "Number of Tickets Purchased",
        type: [
            "event"
        ],
        value: "{{numberoftickets}} ",
        dummyData: "2"
    },
    {
        label: "Ticket Title",
        type: [
            "event"
        ],
        value: "{{tickettitle}} ",
        dummyData: "General Admission"
    }
];
const DEFAULT_EDITOR_FONT_FAMILY = "Poppins";
const getFontFamilyLabel = (fontFamily)=>{
    return fontFamily || "Font";
};
const HEADING_FONT_SIZES = {
    "header-one": 40,
    "header-two": 32,
    "header-three": 24
};
const FontSizeDropdown = (param)=>{
    let { onChange , expanded , onExpandEvent , doCollapse , currentState , config , editorState  } = param;
    var ref;
    const blockType = (ref = editorState === null || editorState === void 0 ? void 0 : editorState.getCurrentContent().getBlockForKey(editorState.getSelection().getStartKey())) === null || ref === void 0 ? void 0 : ref.getType();
    const selectedFontSize = HEADING_FONT_SIZES[blockType] || (currentState === null || currentState === void 0 ? void 0 : currentState.fontSize);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "rdw-fontsize-wrapper rdw-dropdown-wrapper",
        "aria-label": "rdw-font-size-control",
        title: "Font size",
        onClick: onExpandEvent,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "rdw-dropdown-selectedtext",
                children: selectedFontSize ? "".concat(selectedFontSize, "px") : "Size"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: expanded ? "rdw-dropdown-carettoclose" : "rdw-dropdown-carettoopen"
            }),
            expanded ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "rdw-dropdown-optionwrapper rdw-fontsize-optionwrapper",
                onClick: (event)=>event.stopPropagation(),
                children: config.options.map((option)=>{
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "rdw-dropdownoption-default rdw-fontsize-option",
                        "data-active": selectedFontSize === option,
                        onClick: ()=>{
                            onChange(option);
                            doCollapse === null || doCollapse === void 0 ? void 0 : doCollapse();
                        },
                        children: [
                            option,
                            "px"
                        ]
                    }, option);
                })
            }) : null
        ]
    });
};
const FontFamilyDropdown = (param)=>{
    let { onChange , expanded , onExpandEvent , doCollapse , currentState , config  } = param;
    const selectedFontFamily = currentState === null || currentState === void 0 ? void 0 : currentState.fontFamily;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "rdw-fontfamily-wrapper rdw-dropdown-wrapper w-12",
        "aria-label": "rdw-font-family-control",
        title: "Font",
        onClick: onExpandEvent,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "rdw-dropdown-selectedtext min-w-11",
                children: getFontFamilyLabel(selectedFontFamily)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: expanded ? "rdw-dropdown-carettoclose" : "rdw-dropdown-carettoopen ml-1"
            }),
            expanded ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "rdw-dropdown-optionwrapper rdw-fontfamily-optionwrapper",
                onClick: (event)=>event.stopPropagation(),
                children: config.options.map((option)=>{
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "rdw-dropdownoption-default rdw-fontfamily-option",
                        "data-active": selectedFontFamily === option,
                        onClick: ()=>{
                            onChange(option);
                            doCollapse === null || doCollapse === void 0 ? void 0 : doCollapse();
                        },
                        children: getFontFamilyLabel(option)
                    }, option);
                })
            }) : null
        ]
    });
};
const PLACEHOLDER_REGEX = function() {
    let type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "event";
    return new RegExp("{{(".concat(TextEditorPlaceholders.filter((f)=>f.type.includes(type)).map((p)=>p.value.trim().slice(2, -2)).join("|"), ")}}"), "g");
};
const Placeholder = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        spellCheck: false,
        style: {
            padding: "2px 2px",
            borderRadius: "4px",
            backgroundColor: "#fff7cc",
            border: "1px dashed #e0b200",
            fontFamily: "monospace"
        },
        children: props.children
    });
};
const PlaceholderButton = (param)=>{
    let { editorState , onChange , type ="event"  } = param;
    const [isMenuOpen, setIsMenuOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const insertPlaceholder = (value)=>{
        const currentContent = editorState.getCurrentContent();
        const selection = editorState.getSelection();
        const newContent = draft_js__WEBPACK_IMPORTED_MODULE_2__.Modifier.insertText(currentContent, selection, value);
        const newEditorState = draft_js__WEBPACK_IMPORTED_MODULE_2__.EditorState.push(editorState, newContent, "insert-characters");
        onChange(newEditorState) // Update the editor state
        ;
        setIsMenuOpen(false) // Close menu
        ;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "rdw-option-wrapper",
                style: {
                    border: "none",
                    color: "#3333ee"
                },
                onClick: ()=>setIsMenuOpen(!isMenuOpen),
                title: "Insert Dynamic Data",
                children: "Personalise"
            }),
            isMenuOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    backgroundColor: "white",
                    border: "1px solid #ccc",
                    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                    zIndex: 1000,
                    minWidth: "150px"
                },
                children: TextEditorPlaceholders.filter((f)=>f.type.includes(type)).map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            padding: "8px 12px",
                            cursor: "pointer",
                            borderBottom: index < TextEditorPlaceholders.length - 1 ? "1px solid #eee" : "none"
                        },
                        onClick: ()=>insertPlaceholder(item.value),
                        children: item.label
                    }, index))
            })
        ]
    });
};
const placeholderStrategyFull = (contentBlock, callback, contentState)=>{
    findWithRegex(PLACEHOLDER_REGEX("event"), contentBlock, callback);
};
const placeholderStrategyMembership = (contentBlock, callback, contentState)=>{
    findWithRegex(PLACEHOLDER_REGEX("membership"), contentBlock, callback);
};
// NOTE: Outputs
const EditorFullCustomDecorators = [
    {
        strategy: placeholderStrategyFull,
        component: Placeholder
    }
];
const EditorMembershipCustomDecorators = [
    {
        strategy: placeholderStrategyMembership,
        component: Placeholder
    }
] // NOTE: Unused/WIP
 // export const keyBindingFn = (e: SyntheticKeyboardEvent): string | null => {
 //   console.log({ key: e.key })
 //   if (e.key === ' ' && KeyBindingUtil.isCtrlKeyCommand(e))
 //     return 'init-autocomplete'
 //
 //   return getDefaultKeyBinding(e)
 // }
 // export const CustomMention = (props: any) => {
 //   // props.children is the mention text
 //   console.log({ props })
 //   return <span className="custom-mention">{props.children}</span>
 // }
;


/***/ }),

/***/ 58118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5434);





// interface ResizeablePayload {
//   handler: JSX.Element
//   element: JSX.Element
// }
const Resizeable = (param)=>{
    let { children , enabled =true , initalSize , minHeight =0 , className =""  } = param;
    const getInitialSize = ()=>{
        return {
            width: 0,
            height: 0,
            ...initalSize
        };
    };
    const [size, setSize] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(getInitialSize());
    const onMouseDown = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        const startSize = size;
        const startPosition = {
            x: e.pageX,
            y: e.pageY
        };
        const previousCursor = document.body.style.cursor;
        const previousUserSelect = document.body.style.userSelect;
        document.body.style.cursor = "ns-resize";
        document.body.style.userSelect = "none";
        const onMouseMove = (evt)=>{
            setSize((state)=>({
                    ...state,
                    height: Math.max(minHeight, startSize.height === "full" ? 0 : startSize.height - startPosition.y + evt.pageY)
                }));
        };
        const onMouseUp = ()=>{
            document.body.removeEventListener("mousemove", onMouseMove);
            document.body.removeEventListener("mouseup", onMouseUp);
            document.body.style.cursor = previousCursor;
            document.body.style.userSelect = previousUserSelect;
        };
        document.body.addEventListener("mousemove", onMouseMove);
        document.body.addEventListener("mouseup", onMouseUp);
    };
    const resizeHandle = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "absolute bottom-0 left-0 z-20 flex h-5 w-full cursor-pointer select-none items-end justify-center",
        onMouseDown: onMouseDown,
        role: "separator",
        "aria-label": "Resize text area",
        "aria-orientation": "horizontal",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_3__/* .MdDragHandle */ .fE1, {
            className: "pointer-events-none"
        })
    });
    if (!enabled) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
        className: "relative ".concat(className),
        children: children
    });
    const payload = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
        className: "relative ".concat(className),
        style: {
            height: size.height === "full" ? "100%" : "".concat(size.height, "px"),
            minHeight: "".concat(minHeight, "px")
        },
        children: [
            children,
            resizeHandle
        ]
    });
    return payload;
};
/* harmony default export */ __webpack_exports__["Z"] = (Resizeable);


/***/ })

}]);